import { useEffect, useState } from "react";
import { isSessionValid } from "@/utils/auth";

const check = () => {
  try {
    return isSessionValid();
  } catch {
    return false;
  }
};

/**
 * True while this browser holds a valid Lexi session (the same check the
 * protected pages use). Public pages use it to swap "Sign in" for "My tips".
 * Re-checks when another tab signs in/out and when the tab becomes visible.
 */
export function useIsSignedIn() {
  const [signedIn, setSignedIn] = useState(check);

  useEffect(() => {
    const refresh = () => setSignedIn(check());
    const onVisible = () => {
      if (document.visibilityState === "visible") refresh();
    };
    window.addEventListener("storage", refresh);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("storage", refresh);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return signedIn;
}

export default useIsSignedIn;
